import { Grid, List, Typography } from '@mui/material'
import { Droppable } from 'react-beautiful-dnd'

import { AssociationsListItem } from './associations-list-item.component'
import { PlusIcon } from 'src/assets/icons'
import { ISelectedIcon } from '.'
import { AssociationsType } from 'src/types'

import useStyles from './styles'
import { useParams } from 'react-router-dom'
import { ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'
import { HelperWrapper } from '../helper-wrapper'
import { useSteps } from 'src/hooks'
import { useTheme } from '@mui/material'

interface IAssocationListProps {
  selectedIcons?: ISelectedIcon[] | null
  type: AssociationsType
  withDnd: boolean
  disabled?: boolean
  disableItemLink?: boolean
  selectedItems: string[]
}

const AssociationList = ({
  selectedIcons,
  disabled,
  type,
  withDnd,
  disableItemLink,
  selectedItems,
}: IAssocationListProps) => {
  const { accountId } = useParams()
  const { data: steps } = useSteps({})
  const classes = useStyles({ disabled })
  const theme = useTheme()
  const foundItems = steps?.data.filter((item) => selectedItems.includes(item.id))

  return (
    <Droppable isDropDisabled={!withDnd} droppableId="associations-column">
      {(provided) => (
        <List
          className={classes.selectionList}
          disablePadding
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          {selectedIcons?.map(({ icon, text, id, subText, locationName, aiGenerated }, index) => (
            <AssociationsListItem
              route={
                disableItemLink
                  ? null
                  : joinAbsRoute(`${ROUTES.ACCOUNTS}/${accountId}/${type}/${id}`)
              }
              subText={subText}
              withDnd={withDnd}
              icon={icon}
              text={text}
              locationName={locationName}
              key={id}
              index={index}
              id={id}
              item={foundItems?.filter((el) => el.id === id)[0]}
              aiGenerated={aiGenerated}
            />
          ))}
          {provided.placeholder}
          {!disabled && (
            <Grid className={classes.selectionWrapper}>
              <Grid className={classes.selectionItem}>
                <label
                  className={classes.selectionLabel}
                  htmlFor={disabled ? undefined : `id-${type}`}
                >
                  <Grid
                    className={classes.imageIconWrapper}
                    sx={{
                      ':hover': {
                        backgroundColor: theme.palette.custom.grey,
                      },
                    }}
                  >
                    <PlusIcon className={classes.imageIcon} />
                  </Grid>
                </label>
                <Typography className={`${classes.selectionText} ${classes.selectionTextLight}`}>
                  {type === AssociationsType.JOURNEYS ? (
                    <HelperWrapper t="journey-link-button-text" />
                  ) : (
                    <>
                      <HelperWrapper t="association-action" />
                      &nbsp;
                      {type}
                    </>
                  )}
                </Typography>
              </Grid>
            </Grid>
          )}
        </List>
      )}
    </Droppable>
  )
}

export { AssociationList }
